export const RECORD_CHANGE_ROLE = 'RECORD/RECORD_CHANGE_ROLE';
export const UPDATE_DATA = 'RECORD/UPDATE_DATA';


const initialState = {
    index:1,
    pageSize:4,
    contractList:[],

};




export default (state = initialState, action) => {

    switch (action.type) {

        case RECORD_CHANGE_ROLE:
            return {
                ...state,
                role: action.data
            };
        case UPDATE_DATA:
            return {
                ...state,
                [action.subType]: action.data
            };





        default:
            return state;
    }
}


export const dispatch_func = {
    update_data : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_DATA,
                subType:type,
                data: data
        });
        };
    },
    changeRole: (data) => {
        return dispatch => {
            dispatch({
                type: RECORD_CHANGE_ROLE,
                data:data
            });
        }
    },



};


// WEBPACK FOOTER //
// ./src/modules/myContract.js